import React, { useContext } from 'react';
import { MenuItem, ListSubheader } from '@mui/material';

import AnnouncementContext, { ALL_COMMUNITIES_FILTER } from '../../../../context/AnnouncementContext';
import { AnnouncementPublishTab } from '../Announcements/utils';
import { ANNOUNCEMENT_DATE_RANGE_OPTIONS } from '../../feedUtils';
import { GENERIC_COMMUNITY, CommunityType } from '../../../../Model/Community';
import ToggleButtonGroup from '../../../../components/ToggleButtonGroup';

import {
  Rail,
  SectionLabel,
  RowList,
  Row,
  Dropdown,
  ToggleSection,
} from './styles';
import texts from './texts.json';

const DISPLAY_MODE = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
};

const POST_AUTHOR = {
  EVERYONE: 'EVERYONE',
  COACH: 'COACH',
};

const SidebarFilter = () => {
  const {
    selectedPublishTab,
    selectedDateRange,
    setSelectedDateRange,
    communities,
    selectedCommunityFilter,
    setSelectedCommunityFilter,
    hidePinnedPosts,
    setHidePinnedPosts,
    showCoachPostsOnly,
    setShowCoachPostsOnly,
  } = useContext(AnnouncementContext);

  const isScheduledTab = selectedPublishTab === AnnouncementPublishTab.SCHEDULED;

  const { podCommunities, customCommunities, tagCommunities } = communities.reduce(
    (acc, community) => {
      if (community.type === CommunityType.POD) acc.podCommunities.push(community);
      else if (community.type === CommunityType.CUSTOM) acc.customCommunities.push(community);
      else if (community.type === CommunityType.TAG) acc.tagCommunities.push(community);
      return acc;
    },
    { podCommunities: [], customCommunities: [], tagCommunities: [] },
  );

  const pinDisplayOptions = [
    { value: DISPLAY_MODE.SHOW, label: texts.show },
    { value: DISPLAY_MODE.HIDE, label: texts.hide },
  ];

  const postAuthorOptions = [
    { value: POST_AUTHOR.EVERYONE, label: texts.everyone },
    { value: POST_AUTHOR.COACH, label: texts.coach },
  ];

  return (
    <Rail>
      {!isScheduledTab && (
        <>
          <SectionLabel>{texts.dateRange}</SectionLabel>
          <RowList>
            {ANNOUNCEMENT_DATE_RANGE_OPTIONS.map(({ value, label }) => {
              const active = selectedDateRange === value;
              return (
                <Row
                  key={value}
                  type="button"
                  $active={active}
                  onClick={() => setSelectedDateRange(value)}
                  aria-pressed={active}
                >
                  <span>{label}</span>
                </Row>
              );
            })}
          </RowList>
        </>
      )}
      <SectionLabel>{texts.community}</SectionLabel>
      <Dropdown
        value={selectedCommunityFilter}
        onChange={(event) => setSelectedCommunityFilter(event.target.value)}
      >
        <MenuItem value={ALL_COMMUNITIES_FILTER}>{texts.allCommunities}</MenuItem>
        <ListSubheader>{texts.genericCommunities}</ListSubheader>
        {GENERIC_COMMUNITY.map((generic) => (
          <MenuItem key={generic.id} value={generic.id}>{generic.name}</MenuItem>
        ))}
        {podCommunities.length > 0 && <ListSubheader>{texts.podCommunities}</ListSubheader>}
        {podCommunities.map((community) => (
          <MenuItem key={community.id} value={community.id}>{community.name}</MenuItem>
        ))}
        {customCommunities.length > 0 && <ListSubheader>{texts.customCommunities}</ListSubheader>}
        {customCommunities.map((community) => (
          <MenuItem key={community.id} value={community.id}>{community.name}</MenuItem>
        ))}
        {tagCommunities.length > 0 && <ListSubheader>{texts.tagCommunities}</ListSubheader>}
        {tagCommunities.map((community) => (
          <MenuItem key={community.id} value={community.id}>{community.name}</MenuItem>
        ))}
      </Dropdown>
      {!isScheduledTab && (
        <>
          <SectionLabel>{texts.pinPostsDisplay}</SectionLabel>
          <ToggleSection>
            <ToggleButtonGroup
              value={hidePinnedPosts ? DISPLAY_MODE.HIDE : DISPLAY_MODE.SHOW}
              options={pinDisplayOptions}
              onChange={(value) => setHidePinnedPosts(value === DISPLAY_MODE.HIDE)}
              size="small"
            />
          </ToggleSection>
          <SectionLabel>{texts.postsBy}</SectionLabel>
          <ToggleSection>
            <ToggleButtonGroup
              value={showCoachPostsOnly ? POST_AUTHOR.COACH : POST_AUTHOR.EVERYONE}
              options={postAuthorOptions}
              onChange={(value) => setShowCoachPostsOnly(value === POST_AUTHOR.COACH)}
              size="small"
            />
          </ToggleSection>
        </>
      )}
    </Rail>
  );
};

export default SidebarFilter;
